export const GET_SHIZEN_STATS = 'SHIZEN_STATS';
export const GET_SHIZEN_STATS_LOADING = 'SHIZEN_STATS_LOADING';
export const FORMAT_SHIZEN_STATS = 'FORMAT_SHIZEN_STATS';

export default {
  GET_SHIZEN_STATS,
  GET_SHIZEN_STATS_LOADING,
  FORMAT_SHIZEN_STATS,
};
